import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoaderFull from './LoaderFull';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null); // Gebruik null om de laadtoestand aan te geven

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const localStorageUser = localStorage.getItem('bibloUser');
    const user = JSON.parse(localStorageUser || '{}');

    // Controleer of de access token aanwezig is
    if (!accessToken || !refreshToken || !user) {
      setLoggedIn(false);
      return;
    } else {
      setLoggedIn(true);
    }

  }, []);

  // Wacht tot de status is bepaald
  if (loggedIn === null) {
    return <LoaderFull />; // Of een andere laadindicator
  }

  return loggedIn ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
